// Measures visible slides per "page" for slider-custom blocks that opt in via
// data-auto-per-page. Sets data-per-page="N" on the element so CSS can hide
// intermediate pagination dots (see slider-custom.liquid stylesheet).
(() => {
  const init = (comp) => {
    if (comp.dataset.paginationInit === '1') return;
    comp.dataset.paginationInit = '1';
    const scroller = comp.querySelector('[ref="scroller"]');
    if (!scroller) return;
    const update = () => {
      const first = scroller.firstElementChild;
      if (!first) return;
      const slideW = first.getBoundingClientRect().width;
      if (slideW < 10) return;
      const perPage = Math.max(1, Math.round(scroller.clientWidth / slideW));
      comp.dataset.perPage = String(perPage);
    };
    update();
    new ResizeObserver(update).observe(scroller);
  };
  const scan = () => document.querySelectorAll('[data-auto-per-page]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
